<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [pSortableColumn]="col.field==isLab ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field==isLab ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="col.field!=isActive && col.field != isFormat && col.field != isLab && col.field != isFormat"
          class="wrapword">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == isActive">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field==isLab">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" class="h-2rem" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{popupTitle}} Details" position="top" [(visible)]="displayMasterListDialog"  showEffect="fade"
  [modal]="true" [style]="{'width':'800px'}">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <div *ngIf="col.field!=isDefaultLanguage">
          <label>{{col.header}}</label>
        </div>
        <div *ngIf="col.field == isTemplateName">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == isHeight || col.field == isWidth || col.field == 'numberOfParallelLanes'">
          <input type="number" class="form-control" [(ngModel)]="masterList[col.field]">
        </div>
        <div *ngIf="col.field == isActive">
          <p-checkbox id="active" [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
        <div *ngIf="col.field == isLab">
          <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" filter="true"  filterBy="label" placeholder="Select a Lab"
            optionLabel="name" [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="col.field == isEntity">
          <p-dropdown [options]="entityOptions" [(ngModel)]="selectedEntity" filter="true" optionLabel="label"
                    optionValue="value" filterBy="label"
            placeholder="Select an Entity" [style]="{'width':'230px'}" optionLabel="field" [showClear]="true">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>{{formatHeader}}</label>
    </div>
    <div>
      <textarea pInputTextarea [rows]="6" [cols]="88" class="w-full" placeholder="Enter a Format for the template" name="format"
        [(ngModel)]="masterList.format"></textarea>
    </div>
  </div>

  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" class="h-2rem" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterList()"
      label="Save" style="float: right;"></button>
  </div>

</p-dialog>
